import { gql } from '@apollo/client';
export const deleteTeamMemberMutation = gql `
  mutation deleteTeamMember($memberId: UUID!, $teamId: UUID!) {
    deleteTeamMember(id: $memberId, teamId: $teamId) {
      id
    }
  }
`;
